import React from 'react';
import { useTranslation } from 'react-i18next';
import ItmonkeysVideo from '../../../assets/videos/itmonkeys-cyber.mp4';
import DatacenterImage from '../../../assets/images/data-center.jpeg';
import CloudImage from '../../../assets/images/openspaceazure.jpg';
import './IntroSectionCyberIncident.css';

const IntroSectionCyberIncident2: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="intro-section-home intro-section-cyber-incident-2">
      {/* Video and Images Section */}
      <div className="intro-section">
        <div className="intro-row-1">
          <div className="intro-text-1">
            <h2>{t('incidentCyber.section1.title', 'Réaction immédiate')}</h2>
            <h3>{t('incidentCyber.section1.description', 'Face à un incident avéré, les premières heures sont absolument déterminantes. Chaque décision prise sous la pression peut avoir des conséquences irréversibles. Une réponse improvisée peut entraîner des conséquences juridiques, financières et commerciales qui peuvent se répercuter pendant des années.')}</h3>
          </div>
          <div className="intro-image">
            <video
              className="intro-media"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src={ItmonkeysVideo} type="video/mp4" />
              {t('incidentCyber.video.notSupported', 'Votre navigateur ne supporte pas la balise vidéo.')}
            </video>
          </div>
        </div>

        <div className="intro-row-2">
          <div className="intro-text-2">
            <h2>{t('incidentCyber.section2.title', 'Plan de réponse complet')}</h2>
            <h3>{t('incidentCyber.section2.description', 'Notre équipe d\'experts en réponse à incident est spécifiquement entraînée pour gérer les situations de crise les plus intenses. Disponibles 24/7, nous vous apportons la méthodologie, l\'expertise technique et le sang-froid nécessaires pour stabiliser la situation, évaluer les dégâts et déployer un plan d\'action efficace.')}</h3>
          </div>

          <div className="intro-image">
            <img
              className="intro-media"
              src={DatacenterImage}
              alt={t('incidentCyber.section2.imageAlt', 'Security')}
            />
          </div>
        </div>

        <div className="intro-bottom-home">
          <div className="intro-row-1">
            <div className="intro-text-1">
              <h2>{t('incidentCyber.section3.title', 'Votre partenaire spécialisé.')}</h2>
              <h3>{t('incidentCyber.section3.description1', 'Nous maîtrisons les environnements cloud les plus complexes et assurons une gestion fluide et efficace de votre architecture cloud, quelle que soit sa taille.')}</h3>
              <h3>{t('incidentCyber.section3.description2', 'Notre objectif est de vous offrir une infrastructure stable, sécurisée et évolutive, tout en libérant vos ressources internes pour mieux innover et développer votre activité.')}</h3>
            </div>
            <div className="intro-image">
              <img
                src={CloudImage}
                loading="lazy"
                className="intro-media"
                alt={t('incidentCyber.section3.imageAlt', 'Azure OpenAI')}
              />
            </div>
          </div>
        </div>

        <div className="intro-section-formation">
          <div className="centered-title-formation">
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroSectionCyberIncident2;
